module.exports = __webpack_public_path__ + "img/cpp-house-dark-theme.aad4d76e.png";